import {
  GET_USERS_SEND,
  GET_USERS_SUCCESS,
  USER_FORM_SEND,
  UPDATE_USER_FORM,
  USER_FORM_DELETE,
  UPDATE_ACCOUNT_SETTING_FORM,
  UPDATE_PASSWORD_FORM,
  UPDATE_USER_EDEC_INTEGRATION,
  OPEN_LOGIN,
  CLOSE_LOGIN,
  RESET_LOGIN_ATTEMPT,
  RESENT_VALIDATION,
  LOGIN_ATTEMPT_NOT_VERIFIED,
  LOGIN_FORM_SEND,
  DISCONNECT_USER,
  GET_LOCAL_CONFIGURATOR,
  LOGIN_REQUIRED,
  PERMISSION_REFUSED,
  SEND_RECOVER_PASSWORD_FORM,
  SAVE_RECOVER_PASSWORD_FORM,
  LOGIN_SAML,
  CHECK_LOGIN,
  GET_LOCAL_EDEC_INTEGRATION,
  UPDATE_CALCULS_COLUMNS,
  ENABLE_USER_LOADER,
  DISABLE_USER_LOADER,
  RESET_LOGIN_ERROR,
} from "../constants";

export function getUsersSend() {
  return {
    type: GET_USERS_SEND,
  };
}

export function getUsersSuccess(payload) {
  return {
    type: GET_USERS_SUCCESS,
    payload,
  };
}

export function userFormSend(values) {
  return {
    type: USER_FORM_SEND,
    values,
  };
}

export function updateUserForm(values) {
  return {
    type: UPDATE_USER_FORM,
    values,
  };
}

export function deleteUser(userId) {
  return {
    type: USER_FORM_DELETE,
    userId,
  };
}
export function updateAccountSettingForm(values) {
  return {
    type: UPDATE_ACCOUNT_SETTING_FORM,
    values,
  };
}
export function updatePasswordForm(values) {
  return {
    type: UPDATE_PASSWORD_FORM,
    values,
  };
}

export function updateUserEDECIntegration(values) {
  return {
    type: UPDATE_USER_EDEC_INTEGRATION,
    values,
  };
}

export function resetLoginAttempt() {
  return {
    type: RESET_LOGIN_ATTEMPT,
  };
}
export function resentValidation() {
  return {
    type: RESENT_VALIDATION,
  };
}
export function loginAttemptNotVerified(email) {
  return {
    type: LOGIN_ATTEMPT_NOT_VERIFIED,
    email,
  };
}
export function disconnectUser() {
  return {
    type: DISCONNECT_USER,
  };
}
export function openLogin() {
  return {
    type: OPEN_LOGIN,
  };
}
export function closeLogin() {
  return {
    type: CLOSE_LOGIN,
  };
}
export function sendFormLogin(values) {
  return {
    type: LOGIN_FORM_SEND,
    values,
  };
}
export function checkLogin() {
  return {
    type: CHECK_LOGIN,
  };
}
export function loginSaml(values) {
  return {
    type: LOGIN_SAML,
    values,
  };
}
export function getLocalConfigurator() {
  return {
    type: GET_LOCAL_CONFIGURATOR,
  };
}
export function loginRequired() {
  return {
    type: LOGIN_REQUIRED,
  };
}
export function permissionRefused() {
  return {
    type: PERMISSION_REFUSED,
  };
}
export function sendRecoverPasswordForm(values) {
  return {
    type: SEND_RECOVER_PASSWORD_FORM,
    values,
  };
}
export function saveRecoverPasswordForm(values) {
  return {
    type: SAVE_RECOVER_PASSWORD_FORM,
    values,
  };
}

export function getLocalEDECIntegration() {
  return {
    type: GET_LOCAL_EDEC_INTEGRATION,
  };
}

export function updateCalculsColumns(columns) {
  return {
    type: UPDATE_CALCULS_COLUMNS,
    columns,
  };
}

export function enableUserLoader(columns) {
  return {
    type: ENABLE_USER_LOADER,
  };
}

export function disableUserLoader() {
  return {
    type: DISABLE_USER_LOADER,
  };
}

export function resetLoginError() {
  return {
    type: RESET_LOGIN_ERROR,
  };
}
